import { fetchOutfitsCallOptions } from '../../../services/outfits.services';
import { call, select, put, fork, takeLatest } from 'redux-saga/effects';
import { callApi } from '../../api';
import { fetchAutoSuggestOufit, updateOutfitEntities, updateOutfitEntitiesForAllLocales } from './outfits.actions';
import { getOutfitsByIds } from './outfits.reducer';
import { Action } from 'typescript-fsa';
import { normalize, schema } from 'normalizr';

const normalizeOutfit = (outfit: any) => {
  const image = outfit && outfit.images[0];

  return {
    ...outfit,
    imageUrl: image && `${process.env.REACT_APP_CDN_URL}${image.hash}`,
  };
};

export const outfitSchema = new schema.Entity('outfit', undefined, {
  processStrategy: normalizeOutfit,
  idAttribute: (entity: any) => {
    return entity && entity.id;
  },
});

export function* watchForFetchAutoSuggestOutfit() {
  const worker = function*(action: Action<any>) {
    const { outfitId, appId } = action.payload;
    const state = yield select();
    const outfits = yield getOutfitsByIds(state, appId, [outfitId]);
    if (!outfits || outfits.length === 0) {
      yield fork(fetchOutfitsForAppId, appId, [outfitId]);
    }
  };

  yield takeLatest(fetchAutoSuggestOufit, worker);
}

export function* fetchOutfitsForAppId(appId: number, outfitIds: number[]) {
  const { ok, data } = yield call(
    callApi,
    fetchOutfitsCallOptions(appId, outfitIds)
  );

  if (ok && data && data.outfits) {
    const normalized = normalize(data.outfits, [outfitSchema]);
    yield put(
      updateOutfitEntities({ appId, outfits: normalized.entities.outfit })
    );
  }
}

export function* fetchOutfitsForMultipleAppIds(appIds: number[], outfitIds: number[]) {
  const APP_ID_DE = 139;

  const { ok, data } = yield call(
    callApi,
    fetchOutfitsCallOptions(APP_ID_DE, outfitIds)
  );

  if (ok && data && data.outfits) {
    const normalized = normalize(data.outfits, [outfitSchema]);
    yield put(
      updateOutfitEntitiesForAllLocales({ appIds, outfits: normalized.entities.outfit })
    );
  }
}



// WEBPACK FOOTER //
// ./src/store/Entities/Outfits/outfits.saga.ts